import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';

const SvgQqBrandIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' className='QQBrandIcon_svg__icon' viewBox='0 0 1024 1024' {...props}>
    <path fill='#FAAD08' d='M511 957c-80 0-154-25-201-62-24 7-55 17-74 31-17 11-15 23-12 28 13 20 226 13 287 6z' />
    <path fill='#FAAD08' d='M497 957c80 0 153-25 201-62 24 7 55 17 74 31 17 11 15 23 12 28-14 20-226 13-287 6z' />
    <path d='M497 475c132-1 238-26 274-36 8-2 13-6 13-6v-31c0-172-83-345-287-345-205 0-288 173-288 345l1 31s3 4 10 5c33 9 141 36 276 37zm363 145c-8-26-19-57-30-86h-10c-101 29-223 48-316 47h-1c-92 1-213-17-314-46l-11-1-31 86c-38 124-26 176-16 177 20 2 80-94 80-94 0 98 88 248 290 249a718 718 0 0 1 6 0c202-1 290-151 290-249 0 0 59 96 80 94 9-1 22-53-17-177' />
    <path
      fill='#FFF'
      d='M434 317c-28 1-51-30-53-70-1-40 20-73 48-74 28-2 52 30 53 69 2 40-20 74-48 75m207-70c-1 40-25 71-53 70s-49-35-48-75c2-39 25-71 53-69 28 1 50 34 48 74'
    />
    <path
      fill='#FAAD08'
      d='M684 369c-7-18-81-38-172-38h-1c-92 0-165 20-173 38a6 6 0 0 0 0 2l1 4c6 9 88 58 172 58h1c83 0 165-49 171-58a6 6 0 0 0 1-4z'
    />
    <path d='M468 256c1 16-8 30-20 32-12 1-22-10-23-26-2-16 7-30 19-32 12-1 22 10 24 26m73 8c2-4 20-25 55-18 10 2 14 6 15 7 1 2 2 4 0 7-2 7-8 7-11 6-2-1-27-16-50 6-2 2-4 2-7 0-3-1-4-5-2-8' />
    <path
      fill='#FFF'
      d='M504 584h-1c-63 1-140-7-215-21-6 36-10 81-7 136 9 137 92 224 220 225h5c129-1 212-88 221-225 3-55-1-100-7-136-75 14-152 22-216 21'
    />
    <path fill='#EB1C26' d='M323 577v137s65 13 130 4V592c-41-3-85-8-130-15' />
    <path
      fill='#EB1C26'
      d='M788 433s-122 40-284 41h-1c-161-1-283-41-283-41l-41 106c102 33 229 54 324 52h1c96 2 223-19 325-52z'
    />
  </svg>
);
const Memo = memo(SvgQqBrandIcon);
export default Memo;
